import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Table,
  Tooltip,
  Tag,
  Select,
  Radio,
  message,
  Upload,
  Space,
  Divider,
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  FileExcelOutlined,
  UploadOutlined,
  InboxOutlined
} from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { exportAttendanceStatus } from './export/ExportAttendanceStatus';

function UserAttendanceLocation() {
  const token = useSelector((state) => state.user.token);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [form] = Form.useForm();
  const [isAlert, setIsAlert] = useState(false);
  const [textAlert, setTextAlert] = useState('');
  const [isImportModal, setIsImportModal] = useState(false);
  const [load, setLoad] = useState(0);


  const [attendanceOptions, setAttendanceOptions] = useState([]);
  const [attendancePage, setAttendancePage] = useState(1);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [hasMoreAttendance, setHasMoreAttendance] = useState(true);

  const [userOptions, setUserOptions] = useState([]);
  const [userPage, setUserPage] = useState(1);
  const [userLoading, setUserLoading] = useState(false);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [importFile, setImportFile] = useState(null);

  const [page, setPage] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
    sorter: {
      order: 'desc',
      columnKey: 'user_attendance_location_id',
    },
  });

  const titlePage = 'User Status Attendance';

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      render: (_, __, index) =>
        (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
    },
    {
      title: 'Users Code',
      dataIndex: 'users_code',
      key: 'users_code',
      sorter: true,
      render: (_, record) => record.users?.users_code,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      render: (_, record) => record.users?.name,
    },
    {
      title: 'Status',
      dataIndex: 'is_anywhere',
      key: 'is_anywhere',
      render: (_, record) => {
        if (record.is_anywhere) return <Tag color="cyan">anywhere</Tag>;
        if (record.is_location_lock) return <Tag color="geekblue">location lock</Tag>;
        return <Tag color="blue">all locations</Tag>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (val) => moment(val).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              type="primary"
              style={{ marginRight: 10 }}
              onClick={() => openModal('edit', record)}
            >
              <EditOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="primary"
              danger
              onClick={() => modalDeleteData(record)}
            >
              <DeleteOutlined />
            </Button>
          </Tooltip>
        </>
      ),
    },
  ];

  useEffect(() => {
    const order = page.sorter?.order === 'ascend' ? 'asc' : 'desc';
    const columnKey = page.sorter?.columnKey || 'user_attendance_location_id';
    getApi(
      'GET',
      `/userattendancelocation?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`
    );
  }, [JSON.stringify(page), isAlert, load]);

  const getApi = (method, url) => {
    setLoading(true);
    const dataReq = {
      method,
      url,
      data: {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    };
    apiCall(dataReq)
      .then((res) => {
        if (res.status === 'success') {
          setData(res.data.data);
          setPage((prev) => ({
            ...prev,
            pagination: {
              ...prev.pagination,
              total: res.data.total_data,
            },
          }));
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e.message);
      });
  };

  const postApi = async (method, url, values) => {
    setLoading(true);
    setIsAlert(false);
    const dataReq = {
      method,
      url,
      data: {
        data: values,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    };
    await apiCall(dataReq)
      .then((res) => {
        if (res.status === 'success') {
          setDataModal(null);
          setIsModal(false);
          setIsAlert(true);
          setTextAlert(res.message);
          form.resetFields();
        } else {
          modalError(res.message);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error(e.message);
      });
  };

  const modalDeleteData = (v) => {
    Modal.confirm({
      title: 'NOTICE',
      content: 'Do you want to delete this data?',
      onOk: () => postApi('DELETE', '/userattendancelocation/' + v.user_attendance_location_id),
    });
  };

  const fetchAttendanceLocations = async (page = 1, search = '') => {
    setAttendanceLoading(true);
    try {
      const res = await apiCall({
        method: 'GET',
        url: `/attendancelocation?page=${page}&limit=20&search=${search}`,
        data: { headers: { Authorization: 'Bearer ' + token } },
      });
      const items = res.data.data.map((x) => ({
        value: x.attendance_location_id,
        label: x.name +' ('+x.name_set+')',
      }));
      setAttendanceOptions((prev) => (page === 1 ? items : [...prev, ...items]));
      setHasMoreAttendance(items.length === 20);
      setAttendancePage(page);
    } finally {
      setAttendanceLoading(false);
    }
  };

  const onScrollAttendance = (e) => {
    if (
      e.target.scrollTop + e.target.offsetHeight === e.target.scrollHeight &&
      hasMoreAttendance &&
      !attendanceLoading
    ) {
      fetchAttendanceLocations(attendancePage + 1);
    }
  };

  const debouncedAttendanceSearch = debounce((val) => {
    fetchAttendanceLocations(1, val);
  }, 500);

  const fetchUsers = async (page = 1, search = '') => {
    setUserLoading(true);
    try {
      const res = await apiCall({
        method: 'GET',
        url: `/users?page=${page}&limit=20&search=${search}`,
        data: { headers: { Authorization: 'Bearer ' + token } },
      });
      const items = res.data.data.map((x) => ({
        value: x.users_id,
        label: `${x.users_code} - ${x.name}`,
      }));
      setUserOptions((prev) => (page === 1 ? items : [...prev, ...items]));
      setHasMoreUsers(items.length === 20);
      setUserPage(page);
    } finally {
      setUserLoading(false);
    }
  };

  const onScrollUsers = (e) => {
    if (
      e.target.scrollTop + e.target.offsetHeight === e.target.scrollHeight &&
      hasMoreUsers &&
      !userLoading
    ) {
      fetchUsers(userPage + 1);
    }
  };

  const debouncedUserSearch = debounce((val) => {
    fetchUsers(1, val);
  }, 500);

  const openModal = (type, data) => {
    if (type === 'edit' && data) {
      setDataModal(data);

      const status_type = data.is_anywhere
        ? 'anywhere'
        : data.is_location_lock
          ? 'lock'
          : 'all';

      const userId = data.users?.users_id;
      const userCode = data.users?.users_code;
      const userName = data.users?.name;
      const attendanceLocationId = data.attendance_location?.attendance_location_id;
      const nameSet = data.attendance_location?.name_set;
      const nameLoct = data.attendance_location?.name;

      form.setFieldsValue({
        users_id: userId,
        status_type,
        attendance_location_id: data.attendance_location_id,
      });

      setUserOptions([
        {
          value: userId,
          label: `${userCode} - ${userName}`,
        },
      ]);

      setAttendanceOptions([
        {
          value: attendanceLocationId,
          label: nameLoct+' ('+nameSet+')',
        },
      ]);

    } else {
      setDataModal(null);
      form.resetFields();
    }

    fetchUsers(1);
    setIsModal(true);
  };

  const closeModal = () => {
    setDataModal(null);
    setIsModal(false);
    form.resetFields();
  };

  const statusType = Form.useWatch('status_type', form);

  useEffect(() => {
    if (statusType === 'lock') {
      fetchAttendanceLocations(1);
    }
  }, [statusType]);

  const onFinish = (values) => {
    const payload = {
      users_id: values.users_id,
      attendance_location_id: values.attendance_location_id || null,
      is_anywhere: false,
      is_location_lock: false,
      is_all_locations: false,
    };

    // Set salah satu ke true berdasarkan status_type
    if (values.status_type === 'anywhere') {
      payload.is_anywhere = true;
    } else if (values.status_type === 'lock') {
      payload.is_location_lock = true;
    } else if (values.status_type === 'all') {
      payload.is_all_locations = true;
    }

    if (dataModal) {
      postApi('PUT', '/userattendancelocation/' + dataModal.user_attendance_location_id, payload);
    } else {
      postApi('POST', '/userattendancelocation', payload);
    }
  };

  const searchData = (value) => {
    setSearch(value);
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage({
      pagination,
      filters,
      sorter,
    });
    if (pagination.pageSize !== page.pagination?.pageSize) {
      setData([]);
    }
  };

  const openImportModal = () => {
    setIsImportModal(true);
  };

  const handleFileImport = async () => {
    if (!importFile) {
      return message.error("Silakan pilih file terlebih dahulu");
    }

    const formData = new FormData();
    formData.append("file", importFile);

    try {
      setLoading(true);

      const res = await apiCall({
        method: "POST",
        url: "/userattendancelocation/import",
        data: {
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
             Authorization: 'Bearer ' + token
          },
        }
      });

      message.success(res.message || "Import berhasil");
      setIsImportModal(false); // jika pakai modal
      setLoad(load + 1);
      getApi(); // refresh data
    } catch (err) {
      message.error("Gagal import data");
    } finally {
      setLoading(true);
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `${process.env.PUBLIC_URL}/assets/excel/DATA_ATTENDANCE_STATUS_EMPLOYEE.xlsx`;
    link.download = 'DATA_ATTENDANCE_STATUS_EMPLOYEE.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportData = async () => {
    setUserLoading(true);
    try {
      const res = await apiCall({
        method: 'GET',
        url: `/userattendancelocation?nopage=true`,
        data: { headers: { Authorization: 'Bearer ' + token } },
      });
      exportAttendanceStatus(res.data.data)
    } finally {
      setUserLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{titlePage}</title>
      </Helmet>
      {isAlert && (
        <Alert
          message={textAlert}
          type="success"
          banner
          closable
          afterClose={() => setIsAlert(false)}
        />
      )}
      <h3>{titlePage}</h3>
      <Row>
        <Col span={8}>
          <Search
            placeholder="Search"
            allowClear
            enterButton="Search"
            size="middle"
            onSearch={searchData}
          />
        </Col><Col span={16} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <Button onClick={() => exportData(data)}>
            <b>Export</b>
          </Button>
          <Button onClick={openImportModal}>
            <b>Import</b>
          </Button>
          <Button type="primary" onClick={() => openModal('add')}>
            <PlusOutlined />
            <b style={{ marginLeft: 5 }}>Add</b>
          </Button>
        </Col>

      </Row>
      <br />
      <Table
        size="middle"
        columns={columns}
        dataSource={data}
        pagination={page.pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey="user_attendance_location_id"
      />

      <Modal
        title="User Status Attendance"
        open={isModal}
        onOk={form.submit}
        onCancel={closeModal}
        okText="Save"
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="users_id"
            label="User"
            rules={[{ required: true, message: 'User is required!' }]}
          >
            <Select
              showSearch
              placeholder="Search user"
              filterOption={false}
              loading={userLoading}
              onSearch={debouncedUserSearch}
              onPopupScroll={onScrollUsers}
              options={userOptions}
            />
          </Form.Item>

          <Form.Item
            name="status_type"
            label="Attendance Status"
            rules={[{ required: true, message: 'Status is required!' }]}
          >
            <Radio.Group>
              <Radio value="anywhere">Anywhere</Radio>
              <Radio value="lock">Lock Location</Radio>
              <Radio value="all">All Locations</Radio>
            </Radio.Group>
          </Form.Item>

          {statusType === 'lock' && (
            <Form.Item
              name="attendance_location_id"
              label="Select Attendance Location"
              rules={[{ required: true, message: 'Please select location!' }]}
            >
              <Select
                showSearch
                placeholder="Search location"
                filterOption={false}
                loading={attendanceLoading}
                onSearch={debouncedAttendanceSearch}
                onPopupScroll={onScrollAttendance}
                options={attendanceOptions}
              />
            </Form.Item>
          )}
        </Form>
      </Modal>

<Modal
  title="📥 Import Status Absensi"
  open={isImportModal}
  onCancel={() => setIsImportModal(false)}
  footer={null}
  centered
>
  <Space direction="vertical" style={{ width: '100%' }} size="large">
    <div>
      <div>Template</div>
      <br />
      <Button
        type="link"
        icon={<FileExcelOutlined />}
        onClick={handleDownload}
      >
        Download Template
      </Button>
    </div>

    <Divider />

    <Form layout="vertical" onFinish={handleFileImport}>
      <Form.Item
        label="Upload File (.xlsx)"
        name="file"
        rules={[{ required: true, message: 'Wajib unggah file' }]}
      >
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          accept=".xlsx"
          onChange={(info) => setImportFile(info.file)}
        >
          <Button icon={<UploadOutlined />}>Pilih File Excel</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          icon={<InboxOutlined />}
          block
        >
          Import Sekarang
        </Button>
      </Form.Item>
    </Form>
  </Space>
</Modal>

    </div>
  );
}

export default UserAttendanceLocation;
